module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gpzufk/tc-custom/9781526745743.jpg?1729082652298",
      "alt": "This image is the cover for the book Victims of the Oaks Colliery Disaster 1847"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Victims of the Oaks Colliery Disaster 1847\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This new book has developed as a result of the author Jane Ainsworth's deep interest in her coal mining ancestors - both paternal great grandparents, Charles Ernest Hardy and Edwin Hall Bailey, worked in collieries in the Barnsley area as did their descendants. At the end of 2017, Jane transcribed a ledger containing the minutes of the Colliers’ Relief Fund Committee for the 1847 Oaks Colliery Explosion for Barnsley Archives. This stimulated her empathy and curiosity about the lives of the people referred to in the minutes - widows, orphans, and a few survivors of the disaster – as well as the 73 victims. She was determined to research all of the individuals in as much detail as possible, despite the challenge of limited early records, to flesh out their stories and to pay tribute to the families of mineworkers whose lives at that time were considered of little value to the colliery owners and managers. Once again, Jane has created \"a memorial book like no other\" as a contribution to Barnsley’s mining heritage.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Ainsworth\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword History\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0